import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { BasicService } from 'src/app/shared/services/basic.service';
import { MediasService } from 'src/app/shared/services/medias.service';

import { MassActionsService } from '../mass-actions.service';

enum choiceEnum {
  task = 1,
  conv = 2,
}

@Component({
  selector: 'app-export-dialog',
  templateUrl: './export-dialog.component.html',
})
export class ExportDialogComponent {
  choiceEnum = choiceEnum;
  choice = null;
  confirmed = false;
  mail = '';
  number: number;

  constructor(
    private alcmeonContextService: AlcmeonContextService,
    private basicService: BasicService,
    public dialogRef: MatDialogRef<ExportDialogComponent>,
    private massActionsService: MassActionsService,
    private mediasService: MediasService
  ) {
    this.mail = this.alcmeonContextService.self.email;
    this.number = this.massActionsService.idsSelection.length;
  }

  confirm() {
    switch (this.choice) {
      case choiceEnum.task:
        this.confirmed = true;
        this.massActionsService.exportTasks(this.massActionsService.idsSelection).subscribe();
        break;

      case choiceEnum.conv:
        this.confirmed = true;
        this.massActionsService.exportConversations(this.massActionsService.idsSelection).subscribe({
          next: ({ url }) => {
            this.mediasService.downloadFile(url);
          },
          error: () => {
            this.basicService.toastAlert('export/ko');
          },
        });
        break;
    }
  }

  close() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close();
  }
}
